'use client';
import { ComponentType } from 'react';
import { Props as PasswordResetProps } from './password-reset.component';
import { PlaceholderConfig } from '@spa/lib/react/context/PlaceholderContext';
import dynamic from 'next/dynamic';

const DynamicPasswordResetComponent: ComponentType<PasswordResetProps> = dynamic(
  () => import('./password-reset.component')
);

export default DynamicPasswordResetComponent;

export function calculatePasswordResetPlaceholderConfig(): PlaceholderConfig {
  const heightSinceWidth = [
    { sinceWidth: 0, height: 700 },
    { sinceWidth: 768, height: 650 },
    { sinceWidth: 1024, height: 650 }
  ];

  return {
    heightSinceWidth
  };
}
